import { realApi } from './api';

// Visibilidad de cada pantalla para el rol de quien pregunta (sin sesión = público).
export const getVisibilidadPantallas = () => realApi.get('/pantallas/visibilidad');

// Panel de administración (solo ADMIN).
export const getPantallasAdmin = () => realApi.get('/pantallas');
export const actualizarPantalla = (id, cambio) => realApi.patch(`/pantallas/${id}`, cambio);
